import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'

@Component
export default class HistoyTerminalOrders extends Vue {
  @Prop({ default: () => { } }) createDate!: Function

  @Action action_getAnswers: any
  @Mutation CURRENT_ORDER: any
  @Getter getTerminalOrders: any
  @Getter getIsUnderMobile: any;

  setOrder(order: any) {
    if (this.getIsUnderMobile) {
      this.$router.push({ name: 'tracker', params: { order_id: order.id } })
    } else {
      this.CURRENT_ORDER(order)
      // this.action_getAnswers()
    }
  }
}
